import { render } from "./MiniElements.vue?vue&type=template&id=2526aaa9&scoped=true"
const script = {}

import "./MiniElements.vue?vue&type=style&index=0&id=2526aaa9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2526aaa9"

export default script